var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFramerLogo = function SvgIconFramerLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.32 2.63A1 1 0 0 1 5.25 2h13.5a1 1 0 0 1 1 1v6.375a1 1 0 0 1-1 1h-4.235l4.922 4.648a1 1 0 0 1-.687 1.727H13v5.375a1 1 0 0 1-1.687.727l-6.75-6.375a1 1 0 0 1-.313-.727V9.375a1 1 0 0 1 1-1h4.235L4.563 3.727a1 1 0 0 1-.242-1.096m8.078 5.745h5.352V4H7.765zm-.796 2H6.25v4.944L11 19.805V15.75a1 1 0 0 1 1-1h4.235z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFramerLogo;